import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo } from '@apexdesigner/schema-tools';

export const languageAndSkills = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    azerbaijaniLevel: z
      .enum(['Native', 'Excellent', 'Good', 'Satisfactory', 'Poor', 'None'])
      .nullable()
      .optional()
      .describe('Azerbaijani language proficiency.'),

    englishLevel: z
      .enum(['Native', 'Excellent', 'Good', 'Satisfactory', 'Poor', 'None'])
      .nullable()
      .optional()
      .describe('English language proficiency.'),

    arabicLevel: z
      .enum(['Native', 'Excellent', 'Good', 'Satisfactory', 'Poor', 'None'])
      .nullable()
      .optional()
      .describe('Arabic language proficiency.'),

    firstAidCertificate: z
      .enum(['Yes', 'No'])
      .nullable()
      .optional()
      .describe('Whether the candidate has first aid skills and certificate.'),

    behavioralResponse: z
      .string()
      .nullable()
      .optional()
      .describe(
        'Response to behavioral question about handling unfamiliar tasks.',
      ),

    candidateId: z.number().hidden().describe('Foreign key to Candidate'),

    candidate: belongsTo('Candidate'),
  })
  .describe('Language proficiency and additional skills for a candidate.')
  .as('LanguageAndSkills');

export { languageAndSkills as languageAndSkillsSchema };
